import { render } from "./TwoFactorVerifyComponent.vue?vue&type=template&id=a1c22f84"
import script from "./TwoFactorVerifyComponent.vue?vue&type=script&lang=js"
export * from "./TwoFactorVerifyComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/auth/TwoFactorVerifyComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a1c22f84"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a1c22f84', __exports__)) {
    api.reload('a1c22f84', __exports__)
  }
  
  module.hot.accept("./TwoFactorVerifyComponent.vue?vue&type=template&id=a1c22f84", () => {
    api.rerender('a1c22f84', render)
  })

}


export default __exports__